
export async function initializeInputs(data: UserSearchInput,searchStore: any,query: any) {
  let searchValues: UserSearchInput = { ...data };

  searchValues.bodyColor = searchValues.bodyColor || [];
  searchValues.others = false;
  searchValues.otherColors = false;

  const parseQueryArray = (queryString: string): string[] =>
    Array.from(new Set(decodeURIComponent(queryString).split("_")));

  // Process makes
  if (query.makes && typeof query.makes === "string") {
    const queryMakes = parseQueryArray(query.makes);
    const makesId: Set<number> = new Set();
    const foundMakes: Set<{ id: number; name: string }> = new Set();

    searchValues.makes = searchValues.makes || [];

    if (searchStore.getMakes.length === 0) {
      await searchStore.fetchMarks();
    }
    const availableMakes = searchStore.getMakes || [];

    queryMakes.forEach((make) => {
      if (make.toLowerCase().includes("autres")) {
        searchValues.others = true;
      }

      // Search for the make in the store
      const foundMake = availableMakes.find(
        (storeMake) => storeMake?.name?.toLowerCase() === make.toLowerCase()
      );

      if (foundMake) {
        foundMakes.add(foundMake);
        makesId.add(foundMake.id);
      }
    });

    if (makesId.size > 0) {
      await searchStore.fetchModels(Array.from(makesId));
    }
    
    searchValues.makes = Array.from(foundMakes);
  }

// Process models
if (query.models && typeof query.models === "string") {
  const queryModels = parseQueryArray(query.models);
  const foundModels = new Set<fetchResult>();


  searchValues.models = searchValues.models || [];

  
  let allModels: fetchResult[] = [];

  if (Array.isArray(searchStore.getModels)) {
    if (searchStore.getModels.length > 0 && "make" in searchStore.getModels[0]) {
      // Case: Multiple makes
      allModels = searchStore.getModels.flatMap((storeMake) => storeMake.models || []);
    } else {
      // Case: Already models array (single make)
      allModels = searchStore.getModels;
    }
  }


  queryModels.forEach((model) => {
    const matchedModel = allModels.find(
      (storeModel) => storeModel.name?.toLowerCase() === model.toLowerCase()
    );

    if (matchedModel) {
      foundModels.add(matchedModel);
    }
  });


  searchValues.models = Array.from(foundModels);
}


  // Process categories
  if (query.categories && typeof query.categories === "string") {
    searchValues.categories = parseQueryArray(query.categories);
  }

  // Process numeric values
  const numericFields = [
    "minPrice",
    "maxPrice",
    "minKilometers",
    "maxKilometers",
    "fromRegYear",
    "toRegYear",
  ] as const;

  numericFields.forEach((field) => {
    if (query[field]) {
      searchValues[field] = Number(query[field]);
    }
  });

  // Process string array fields
  const stringArrayFields = ["fuelTypes", "transmissions", "bodyColor",'cities'] as const;

  stringArrayFields.forEach((field) => {
    if (query[field] && typeof query[field] === "string") {
      searchValues[field] = parseQueryArray(query[field]);
    }
  });

  // Process `placesNbr`
  if (query.placesNbr && typeof query.placesNbr === "string") {
    searchValues.placesNbr = parseQueryArray(query.placesNbr).map(Number);
  }

 

  return searchValues;
}



export const searchQuerys = (searchFilters: UserSearchInput, searchStore: any) => {
  

  const queryParams = new URLSearchParams();

  for (const key in searchFilters) {
    if (key === "front" || key === "makesIds" || key === "modelsIds") continue;

    const value = searchFilters[key];

    if (Array.isArray(value) && value.length > 0) {
      // Handle array values
      const encodedValue = Array.from(
        new Set(value.map((item) => encodeURIComponent(item.name || item)))
      ).join("_");
      queryParams.append(key, encodedValue);
    } else if (typeof value === "boolean") {
      if (value) queryParams.append(key, "true");
      continue;
    } else if (value !== null && value !== undefined && !Array.isArray(value)) {
      if (typeof value === "string" && value.trim() === "") continue;
      // Handle non-array values
      queryParams.append(key, encodeURIComponent(value));
    }
  }
  
  searchStore.userInput = { ...searchStore.userInput, ...searchFilters }; // Fix merging of userInput

  return queryParams;
};
